import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/authorization';

const API = process.env.REACT_APP_API_NODE_URL;

export default function GoogleSignIn() {
  const [loginFailed, setLoginFailed] = useState(false);
  const navigate = useNavigate();
  const { refresh } = useAuth();

  const handleGoogleSuccess = async (response: any) => {
    try {
      const credential = response?.credential;
      if (!credential) throw new Error('Missing Google credential');

      const res = await fetch(`${API}auth/signin`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ credential }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err?.error || `Google login failed (HTTP ${res.status})`);
      }

      await refresh();
      navigate('/stores', { replace: true });
    } catch (err) {
      console.error('Google login failed:', err);
      setLoginFailed(true);
    }
  };

  return (
    <>
      <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={() => setLoginFailed(true)}
        width={"100%"}
      />
      {loginFailed && (
        <span className="error-message">Login failed. Please try again.</span>
      )}
    </>
  );
}